import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as globalActions from 'ui/containers/App/actions';
import { PAGE } from 'common/constants';
import Icon from 'assets/icons/Insent-icon.svg';
import { slideUp } from 'styles/animation';
import { eventTypes } from 'utils/eventTypes';
import {
  saveEventToLocalStorage,
  saveToLocalStorage,
  getFromLocalStorage,
} from 'utils/saveToLocalStorage';
import theme from 'styles/theme';
import checkIcon from 'utils/checkIcon';

import localStorageTemplates from 'common/local-storage-templates';
import {TRIGGER_EVENT_TYPES, WINDOW_POSTMESSAGE_TYPES} from "../App/constants";
import * as globalSelectors from "../App/selectors";
import { postMessageToWindow } from 'utils/index';
const LauncherContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const LauncherButton = styled.div`
  position: relative;
  background: transparent;
  cursor: pointer;
  display: block;
  border: 0;
  height: inherit;
  width: inherit;
  box-sizing: border-box;
  z-index: ${p => p.theme.zIndex.base2};
  &:focus {
    outline: none;
  }

  opacity: 0;
  transform: translateY(10px);
  animation: ${slideUp} 0.5s ease-in-out 0.08s forwards;
`;

const LauncherIconContainer = styled.div`
  background: ${p => p.bgColor};
  border-radius: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  height: 60px;
  width: 60px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const LauncherIcon = styled.div`
  background-image: url(${p => p.logo || Icon});
  background-size: contain;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
  border-radius: ${p => (p.isIcon ? `0` : `50px`)};
`;

const LauncherPill = styled.div`
  align-items: center;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  position: absolute;
  top: -6px;
  display: flex;
  right: -6px;
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
  background: #fb5151;
  justify-content: center;
`;

const Launcher = props => {
  const {
    setActivePageStart,
    setPopup,
    userConfig,
    currentChannel,
    userData,
    notificationRead,
    setNotificationRead,
    customCookies,
  } = props;
  const launcherClickAction = e => {
    setPopup({});
    const event = {
      eventType: eventTypes.WIDGET_ICON_CLICKED,
      timestamp: Date.now(),
      url: userConfig.blogUrl,
      props: {
        channelId: currentChannel,
      },
    };
    let disabledConversations = JSON.parse(
      getFromLocalStorage(localStorageTemplates.disabledConversations) || '[]'
    );

    const updatedDisabledConversations = disabledConversations.filter(
      channelId => channelId !== currentChannel
    );
    saveToLocalStorage(
      localStorageTemplates.disabledConversation,
      JSON.stringify(updatedDisabledConversations)
    );
    setNotificationRead(0);
    saveToLocalStorage(localStorageTemplates.notificationRead, 0);

    saveEventToLocalStorage(event);
    const { eventListenerName } = userConfig;
    postMessageToWindow(
        {
          type: eventListenerName,
          event: WINDOW_POSTMESSAGE_TYPES.triggerEvent,
          eventType: TRIGGER_EVENT_TYPES.startConversation,
          eventData: "Conversation Started"
        },
        '*'
    );
    if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
      postMessageToWindow(
          {
            type: eventListenerName,
            event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
            customCookies,
          },
          '*'
      );
    }
    setActivePageStart(PAGE.CONVO);
    e.preventDefault();
  };

  return (
    <LauncherContainer id="insent-launcher-container">
      <LauncherButton id="insent-launcher-button" type="button" onClick={launcherClickAction}>
        <LauncherIconContainer
            id="insent-launcher-icon-container"
            bgColor={ userData ? (userData.settings ? (userData.settings.color ? userData.settings.color.headerBackgroundColor : theme.palette.primary) : theme.palette.primary) : theme.palette.primary }
        >
          {notificationRead > 0 && <LauncherPill>{notificationRead}</LauncherPill>}
          <LauncherIcon
            id="insent-launcher-icon"
            logo={userData ? (userData.settings ? (userData.settings.bot ? userData.settings.bot.widgetIcon : userData.settings.bot.img) : '') : ''}
            isIcon={checkIcon(userData ? (userData.settings ? (userData.settings.bot ? userData.settings.bot.widgetIcon : userData.settings.bot.img) : '') : '')}

          />
        </LauncherIconContainer>
      </LauncherButton>
    </LauncherContainer>
  );
};

Launcher.propTypes = {
  toggle: PropTypes.func,
  isChatOpen: PropTypes.bool,
  badge: PropTypes.number,
  fullScreenMode: PropTypes.bool,
  openLauncherImage: PropTypes.string,
  closeImage: PropTypes.string,
  popup: PropTypes.string,
  popupMessage: PropTypes.string,
  removePopupMessage: PropTypes.func,
};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    customCookies: globalSelectors.makeSelectCustomCookies(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    setActivePageStart: page => dispatch(globalActions.setActivePage.start(page)),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Launcher);
